// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const exeggutor_alola: PokeData = {
  "id": 10114,
  "name": "exeggutor-alola",
  "height": 109,
  "weight": 4156,
  "base_experience": 186,
  "types": [
    PokeType.GRASS,
    PokeType.DRAGON
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "leech-seed",
    "solar-beam",
    "stun-spore",
    "confusion",
    "hypnosis",
    "reflect",
    "egg-bomb",
    "barrage",
    "giga-drain",
    "synthesis",
    "uproar",
    "extrasensory",
    "bullet-seed",
    "worry-seed",
    "seed-bomb",
    "dragon-pulse",
    "leaf-storm",
    "power-whip",
    "wood-hammer",
    "psyshock",
    "dragon-hammer"
  ],
  "moves": [
    "solar-beam",
    "stun-spore",
    "reflect",
    "synthesis",
    "bullet-seed",
    "dragon-pulse",
    "power-whip",
    "wood-hammer",
    "branch-poke",
    "vine-whip",
    "overgrowth",
    "dragon-dance",
    "draco-meteor"
  ],
  "evolution_chain": {
    "id": 45,
    "item": null,
    "species": [
      {
        "name": "exeggcute",
        "order": 111,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "exeggutor",
        "order": 112,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 102,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 70,
    "ability_power": 194
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
